import { LegalLayout } from "@/components/LegalLayout";
import { LEGAL_DOCS } from "@/data/legal";

export default function LegalPage({ docKey }) {
  return <LegalLayout doc={LEGAL_DOCS[docKey]} />;
}
